import Vue from 'vue'
import VueRouter from 'vue-router'
import StudentForm from '../components/StudentForm';
import Login from '../components/Account/Login';
import StudentsList from '../components/StudentsList';
import StudentInformation from '../components/StudentInformation';
import InvoiceList from '../components/InvoiceList';
import PaymentList from '../components/PaymentList';
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: StudentForm,
    component: StudentForm
  },
  {
    path: '/login',
    name: Login,
    component: Login,
  },
  {
    path: '/Students',
    name: StudentsList,
    component: StudentsList
  },
  {
    path: '/Student/information',
    name: StudentInformation,
    component: StudentInformation
  },
  {
    path: '/Invoices',
    name: InvoiceList,
    component: InvoiceList
  },
  {
    path: '/Payments',
    name: PaymentList,
    component: PaymentList
  },
]

const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  if (to.path !== '/login') {
    if (to.path === '/') {
      next(); 
    } else {
      if (localStorage.getItem('token')) {
        next(); 
      } else {
        Vue.toasted.error("You need to log in!", {
          position: "bottom-center", 
          duration: 3000, 
          singleton: true, 
        });
        next('/login'); 
      }
    }
  } else {
    next();
  }
});



export default router;